import './css/App.css';
import Content from './components/Content.js';

function App() {
  return (
    <div className="App">
      <Content />
    </div>
  );
}

export default App;
